import { httpClient } from "@/app/client/httpClient";
import { sendAdjustEvent } from "@/plugins/adjust";
import { sendFirebaseCustomEvent } from "@/plugins/firebase";

class FavoriteService {
  fetchFavoriteOffices(
    query?: Partial<{
      limit: number;
      offset: number;
      is_favorite: string;
      office: number;
    }>
  ) {
    return httpClient.accounts.me.favorite_offices.$get({
      query: {
        limit: query?.limit,
        offset: query?.offset,
        /* eslint-disable @typescript-eslint/naming-convention */
        is_favorite: query?.is_favorite,
        office: query?.office
        /* eslint-enable */
      }
    });
  }

  async createFavoriteOffices(body: { office: number; isFavorite: boolean }) {
    const favoriteOffice = await httpClient.accounts.me.favorite_offices.$post({
      body
    });
    sendAdjustEvent("REGISTER_FAVORITE");
    sendFirebaseCustomEvent("register_favorite", {
      office_id: body.office
    });
    return favoriteOffice;
  }

  async updateFavoriteOffices(
    officeId: number,
    body: { office: number; isFavorite: boolean }
  ) {
    const favoriteOffice = await httpClient.accounts.me.favorite_offices
      ._id(officeId)
      .$patch({ body });
    if (favoriteOffice.isFavorite) {
      sendAdjustEvent("REGISTER_FAVORITE");
      sendFirebaseCustomEvent("register_favorite", {
        office_id: officeId
      });
    }
    return favoriteOffice;
  }
}

export const favoriteService = new FavoriteService();
